import React from "react";

const JobListContainer = (props) => {
  return (
    <>
      <div
        className="thick-scrollbar"
        ref={props.devRef}
        onScroll={props.onDevScroll}
        style={{
          flex: "1 1 auto",
          width: "100%",
          minHeight: 0,
          height: "100%",
          alignSelf: "stretch",
          overflowX: "scroll",
          overflowY: "scroll",
          border: "1px solid lightgrey",
          borderRadius: "5px",
          scrollbarGutter: "stable both-edges",
        }}
      >
        {props.children}
      </div>

    </>
  );
};

export default JobListContainer;
